import { render, staticRenderFns } from "./PopoverMenuItem.vue?vue&type=template&id=49a64050&"
import script from "./PopoverMenuItem.vue?vue&type=script&lang=js&"
export * from "./PopoverMenuItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports